import React from "react";
import { KeyboardAvoidingView, ScrollView } from "react-native";

import tw from "twrnc";

const OnboardingContent = ({
  children,
  wide = false,
  keyboardVerticalOffset = 40,
}) => {
  return (
    <KeyboardAvoidingView
      behavior="padding"
      style={tw`flex-1`}
      keyboardVerticalOffset={keyboardVerticalOffset}
    >
      <ScrollView
        padder
        // Without this, a tap on Continue while the keyboard is open only
        // closes the keyboard (Android), and the button moves before a second tap.
        keyboardShouldPersistTaps="handled"
        style={tw`flex-1 bg-transparent`}
        contentContainerStyle={[
          // flexGrow (not flex-1): short steps stay centred, tall ones scroll
          // instead of spilling over the header and the Continue button.
          tw`flex-grow self-center justify-center p-5`,
          {
            maxWidth: wide ? 660 : 440, //1294
            width: "100%",
          },
        ]}
      >
        {children}
      </ScrollView>
    </KeyboardAvoidingView>
  );
};

export default OnboardingContent;
